var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 56,
    viewBox: "0 0 47 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 41.975H30C31.8333 41.975 33.3333 40.475 33.3333 38.6417V21.975H38.6333C41.6 21.975 43.1 18.375 41 16.275L25.7 0.975C24.4 -0.325 22.3 -0.325 21 0.975L5.7 16.275C3.6 18.375 5.06667 21.975 8.03333 21.975H13.3333V38.6417C13.3333 40.475 14.8333 41.975 16.6667 41.975ZM3.33333 48.6417H43.3333C45.1667 48.6417 46.6667 50.1417 46.6667 51.975C46.6667 53.8083 45.1667 55.3083 43.3333 55.3083H3.33333C1.5 55.3083 0 53.8083 0 51.975C0 50.1417 1.5 48.6417 3.33333 48.6417Z",
    fill: "#3A61FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7d1a487aa0558e12eb78c99ef24e6567.svg";
export { ForwardRef as ReactComponent };